import { cn, Row } from '@rematter/ui-web';
import { LucideIcon } from 'lucide-react';

export type FormSectionProps = {
  children: React.ReactNode;
  icon?: LucideIcon;
  title: React.ReactNode;
  className?: string;
};

export const FormSection = ({
  children,
  icon: Icon,
  title,
  className,
}: FormSectionProps) => (
  <div
    className={cn(
      '@FormSection grid gap-3',
      Icon ? 'grid-cols-[max-content_auto]' : 'grid-cols-1',
      className,
    )}
  >
    {Icon && (
      <div className={'rounded bg-neutral/7 p-2'}>
        <Icon className="size-4 opacity-60" />
      </div>
    )}
    <Row className={'font-semibold'}>{title}</Row>
    {Icon && <div />}
    <div>{children}</div>
  </div>
);
